module.exports = __webpack_public_path__ + "img/logo.864ef490.png";